require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-unterkohlstaetten.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-unterkohlstaetten");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-unterkohlstaetten!./.cache/json/betreuungseinrichtungen-oberwart-unterkohlstaetten.json
// module id = 1027
// module chunks = 231608221292675